import type { CityConfig } from "../city-template/types";

export const greenvilleConfig: CityConfig = {
  city: "Greenville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "greenville",
  route: "/cities/greenville",
  title: "Emergency Passport Greenville, NC | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Greenville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Pitt County and the ECU area. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Greenville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Greenville and Pitt County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Greenville%20North%20Carolina%20cityscape%20at%20golden%20hour%20with%20East%20Carolina%20University%20campus%20visible%2C%20charming%20downtown%20historic%20district%20with%20brick%20buildings%20and%20tree-lined%20streets%2C%20lush%20green%20trees%20of%20the%20eastern%20North%20Carolina%20flatlands%2C%20warm%20sunset%20light%20over%20Pitt%20County%2C%20clean%20sky%20with%20soft%20clouds%2C%20professional%20cityscape%20photography%20with%20vibrant%20warm%20colors%20and%20small-town%20southern%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=greenville-hero-nc-001&orientation=landscape",
  heroImageAlt: "Greenville North Carolina downtown with East Carolina University campus at golden hour in Pitt County flatlands",
  geoPosition: "35.6127;-77.3664",
  geoPlacename: "Greenville, North Carolina",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 330 miles from Greenville via I-95 and I-85",
  },
  nearbyCitiesZips: [
    { name: "Greenville", zips: "27834, 27835, 27836, 27858" },
    { name: "Winterville", zips: "28590" },
    { name: "Farmville", zips: "27828" },
    { name: "Ayden", zips: "28513" },
    { name: "Grifton", zips: "28530" },
    { name: "Bethel", zips: "27812" },
    { name: "Belvoir", zips: "27817" },
    { name: "Stokes", zips: "27884" },
    { name: "Simpson", zips: "27879" },
    { name: "Robersonville", zips: "27871" },
    { name: "Williamston", zips: "27892" },
    { name: "Tarboro", zips: "27886" },
    { name: "Rocky Mount", zips: "27801, 27802, 27803, 27804" },
    { name: "Wilson", zips: "27893, 27894, 27895, 27896" },
    { name: "Goldsboro", zips: "27530, 27531, 27532, 27533, 27534" },
    { name: "New Bern", zips: "28560, 28561, 28562, 28563, 28564" },
    { name: "Kinston", zips: "28501, 28502, 28503, 28504" },
    { name: "Jacksonville", zips: "28540, 28541, 28542, 28543, 28544, 28545, 28546, 28547" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Pitt County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Eastern NC Hub", desc: "Serving Greenville, ECU area, Winterville, and all of Pitt County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Fast passport renewal in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Emergency passport help in Fayetteville, NC", route: "/cities/fayetteville" },
    { name: "Urgent passport services in Jacksonville, NC", route: "/cities/jacksonville-nc" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
    { name: "Same-day passport help in Goldsboro, NC", route: "/cities/goldsboro" },
    { name: "Fast passport renewal in Wilson, NC", route: "/cities/wilson" },
    { name: "Emergency passport help in New Bern, NC", route: "/cities/new-bern" },
    { name: "Urgent passport services in Rocky Mount, NC", route: "/cities/rocky-mount" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Greenville remotely via secure courier. We do not have a walk-in office in Greenville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Pitt County and eastern North Carolina travelers.",
  fpcOfficeDistance: "Serving all of Pitt County and eastern North Carolina",
  serviceAreaIntro: "From downtown Greenville's historic district to the East Carolina University campus, from the Winterville suburbs to the rural communities of Farmville, Ayden, and Grifton — Fast Passport Center serves the entire Greenville region. We regularly help travelers from Tarboro, Rocky Mount, Wilson, Goldsboro, New Bern, and Kinston get their passports fast.",
  nearbyCitiesIntro: "We serve all Greenville neighborhoods and the surrounding eastern North Carolina area including Winterville, Farmville, Ayden, Grifton, Bethel, Belvoir, Stokes, Simpson, Robersonville, Williamston, Tarboro, Rocky Mount, Wilson, Goldsboro, New Bern, Kinston, and Jacksonville. If you are anywhere in Pitt County or eastern North Carolina, we have you covered.",
  howItWorksIntro: "Most Greenville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Greenville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Greenville and Pitt County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Greenville? Here are the most common ones we hear from Pitt County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Greenville international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Dr. Emily W.",
      location: "Greenville, NC",
      rating: 5,
      text: "ECU faculty travel to conferences internationally. When my passport expired 3 days before a trip to Barcelona, Fast Passport Center had my renewal in 36 hours. I didn't miss a single session.",
      service: "Passport Renewal",
    },
    {
      name: "Marcus J.",
      location: "Winterville, NC",
      rating: 5,
      text: "Emergency passport for a family funeral in Jamaica. Got it in 29 hours. The team was compassionate and efficient. I didn't have to drive to Atlanta at all.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah K.",
      location: "Farmville, NC",
      rating: 5,
      text: "First passport for my 14-year-old before a school trip to France. Fast Passport Center made the whole process easy. Had her passport in 5 days. Highly recommend for eastern NC families.",
      service: "Child Passport",
    },
    {
      name: "David P.",
      location: "Ayden, NC",
      rating: 5,
      text: "Lost my passport 5 days before a business trip to London. Fast Passport Center had a replacement in 31 hours. The best passport service for anyone in Pitt County.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "greenville-1",
      name: "Greenville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2210 W Arlington Blvd",
      city: "Greenville",
      state: "NC",
      zip: "27834",
      phone: "(252) 758-6181",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Greenville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance.",
      icon: "ri-mail-line",
    },
    {
      id: "greenville-2",
      name: "Winterville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4141 S Memorial Dr",
      city: "Winterville",
      state: "NC",
      zip: "28590",
      phone: "(252) 756-1423",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles south of Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Winterville and southern Greenville residents. Less crowded than main Greenville office. Photo services nearby.",
      icon: "ri-mail-line",
    },
    {
      id: "greenville-3",
      name: "Farmville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3731 N Main St",
      city: "Farmville",
      state: "NC",
      zip: "27828",
      phone: "(252) 753-2131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles west of Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves western Pitt County and Farmville area. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "greenville-4",
      name: "Tarboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "624 W Wilson St",
      city: "Tarboro",
      state: "NC",
      zip: "27886",
      phone: "(252) 823-2101",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles north of Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Pitt County and Edgecombe County. Alternative for Greenville north side residents.",
      icon: "ri-mail-line",
    },
    {
      id: "greenville-5",
      name: "Wilson Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "202 Ward Blvd",
      city: "Wilson",
      state: "NC",
      zip: "27893",
      phone: "(252) 237-0131",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles west of Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Wilson County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "greenville-6",
      name: "Rocky Mount Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "219 N Church St",
      city: "Rocky Mount",
      state: "NC",
      zip: "27801",
      phone: "(252) 446-6141",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "45 miles northwest of Greenville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Nash and Edgecombe County. Alternative for northern Pitt County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Greenville photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Pitt County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Greenville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Pitt County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Greenville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Greenville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Greenville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Greenville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Greenville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5+ hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Greenville?", a: "Fast Passport Center offers fast passport renewal in Greenville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Greenville?", a: "The nearest regional passport agency to Greenville is the Atlanta Passport Agency, approximately 330 miles away via I-95 and I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Greenville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Greenville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 5+ hours from Greenville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Pitt County residents." },
    { q: "Do you serve the entire eastern North Carolina area?", a: "Absolutely. Fast Passport Center serves the entire eastern North Carolina area including Greenville, Winterville, Farmville, Ayden, Grifton, Bethel, Belvoir, Stokes, Simpson, Robersonville, Williamston, Tarboro, Rocky Mount, Wilson, Goldsboro, New Bern, Kinston, and Jacksonville. Our courier service works seamlessly from any address in Pitt County and surrounding areas." },
    { q: "Can I expedite a child passport in Greenville?", a: "Yes. Fast Passport Center expedites child passports in Greenville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Pitt County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Greenville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Greenville", address: "2100 E 10th St, Greenville, NC 27858", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Greenville", address: "2120 E Fire Tower Rd, Greenville, NC 27858", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart Supercenter — Greenville", address: "2100 E Fire Tower Rd, Greenville, NC 27858", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Winterville", address: "4141 S Memorial Dr, Winterville, NC 28590", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Wilson", address: "301 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walmart — Wilson", address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896", hours: "Mon–Sun: 6AM–11PM" },
    { name: "CVS Pharmacy — Rocky Mount", address: "1200 S Wesleyan Blvd, Rocky Mount, NC 27803", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Goldsboro", address: "2205 E Ash St, Goldsboro, NC 27530", hours: "Mon–Sun: 7AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Greenville",
      address: "207 E Arlington Blvd, Greenville, NC 27834",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Wilson",
      address: "2915 Raleigh Rd Pkwy W, Wilson, NC 27896",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Rocky Mount",
      address: "1331 S Wesleyan Blvd, Rocky Mount, NC 27803",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Nash and Edgecombe County. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Goldsboro",
      address: "2133 E Ash St, Goldsboro, NC 27530",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wayne County. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "PGV",
      name: "Pitt-Greenville Airport",
      distance: "3 miles south of Greenville",
      address: "400 Airport Rd, Greenville, NC 27834",
      note: "Regional airport serving eastern North Carolina with American Airlines flights to Charlotte (CLT). Connecting flights available to international destinations.",
      flightUrl: "https://www.flypgv.com/",
      flightLabel: "PGV Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "90 miles west of Greenville",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international hub with direct flights to Europe, Canada, Mexico, and the Caribbean. The closest major airport for Greenville travelers.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "220 miles west of Greenville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "American Airlines hub with the most international flight options from North Carolina. Consider for long-haul international travel.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
};